__turbopack_context__.v({
  "animated-gradient-text": "index-module-scss-module__OZXxSG__animated-gradient-text",
  "gradient-overlay": "index-module-scss-module__OZXxSG__gradient-overlay",
  "text-content": "index-module-scss-module__OZXxSG__text-content",
  "with-border": "index-module-scss-module__OZXxSG__with-border",
});
